import React from "react";
import { QRCodeSVG } from "qrcode.react";
import fbrIcon from "../assets/fbr.png";
const invoiceData = {
  serial: "052",
  date: "06/08/2025",
  supplier: {
    name: "Le-Topical (Pvt) Ltd.",
    address: "Plot No. 17-18, Street No. 2\n18 km Ferozepur Road Opp J Tech, Lahore.",
    gst: "03-00-4352-738-10",
    nationalTax: "4352738-8",
  },
  buyer: {
    name: "JS Bank Limited.",
    address: "Plot# S-R 6/10, Frerer Road 7-A, 7th Floor Fakhri Trade Center, Karachi.",
    salesTaxNo: "17-00-9713-027-28",
    nationalTax: "2663703-7",
  },
  items: [
    { qty: 2000, desc: "Priority Banking Account Op", price: 347, excl: 694000, tax: 124920, incl: 818920 },
    { qty: 1000, desc: "Priority Banking Brochure", price: 180, excl: 180000, tax: 32400, incl: 212400 },
    { qty: 2000, desc: "Priority Banking Large Enve", price: 78, excl: 156000, tax: 28080, incl: 184080 },
    { qty: 2000, desc: "Priority Banking Letter Head", price: 37, excl: 74000, tax: 13320, incl: 87320 },
    { qty: 2000, desc: "Priority Banking Small Enve", price: 49, excl: 98000, tax: 17640, incl: 115640 },
    { qty: 2000, desc: "Priority Banking SS Card (Fo", price: 24, excl: 48000, tax: 8640, incl: 56640 },
    { qty: 2000, desc: "Priority Banking SS Card (Lo", price: 24, excl: 48000, tax: 8640, incl: 56640 },
  ],
  totalExcl: 1298000,
  totalTax: 233640,
  totalIncl: 1531640,
  signature: "M. Abid - Chief Accountant",
  fbr_qrcode: "https://fbr.gov.pk/sample",
};

const InvoicePrint = React.forwardRef(({ invoice }, ref) => {
  const {
    serial,
    date,
    supplier,
    buyer,
    items,
    totalExcl,
    totalTax,
    totalIncl,
    signature,
    fbr_qrcode,
  } = invoiceData;

  return (
    <div ref={ref} style={styles.invoice}>
      <div style={styles.heading}>SALES TAX INVOICE</div>

      <div style={styles.row}>
        <div>Serial No.: <b>{serial}</b></div>
        <div>Date: <b>{date}</b></div>
        <div style={{ flex: 1 }} />
      </div>

      <div style={styles.row}>
        <div>Supplier’s Name: <b>{supplier.name}</b></div>
        <div style={{ flex: 1 }} />
        <div>Buyer’s Name: <b>{buyer.name}</b></div>
      </div>

      <div style={styles.row}>
        <div style={styles.block}>
          <div>Address: {supplier.address}</div>
          <div>Sales Tax No.: {supplier.gst}</div>
          <div>National Tax No.: {supplier.nationalTax}</div>
        </div>
        <div style={styles.block}>
          <div>Address: {buyer.address}</div>
          <div>Sales Tax No.: {buyer.salesTaxNo}</div>
          <div>National Tax No.: {buyer.nationalTax}</div>
        </div>
      </div>

      <div style={{ textAlign: "right", fontSize: 13, marginTop: 4, fontStyle: "italic" }}>
        (Description code: 4910)
      </div>

      <table style={styles.table}>
  <thead>
    <tr>
      <th style={styles.th}>Qty</th>
      <th style={styles.th}>Description</th>
      <th style={styles.th}>Price</th>
      <th style={styles.th}>Value Exclusive Sales Tax</th>
      <th style={styles.th}>Rate of Sales Tax</th>
      <th style={styles.th}>Total Sales Tax Payable</th>
      <th style={styles.th}>Value Inclusive Sales Tax</th>
    </tr>
  </thead>
  <tbody>
    {items.map((item, i) => (
      <tr key={i}>
        <td style={styles.td}>{item.qty.toLocaleString()}</td>
        <td style={styles.td}>{item.desc}</td>
        <td style={styles.td}>{item.price}</td>
        <td style={styles.td}>{item.excl.toLocaleString()}</td>
        <td style={styles.td}>18%</td>
        <td style={styles.td}>{item.tax.toLocaleString()}</td>
        <td style={styles.td}>{item.incl.toLocaleString()}</td>
      </tr>
    ))}
    <tr style={styles.totalRow}>
      <td colSpan={3} style={{ ...styles.td, textAlign: "right", fontWeight: "bold" }}>Total</td>
      <td style={{ ...styles.td, fontWeight: "bold" }}>{totalExcl.toLocaleString()}</td>
      <td style={styles.td}></td>
      <td style={{ ...styles.td, fontWeight: "bold" }}>{totalTax.toLocaleString()}</td>
      <td style={{ ...styles.td, fontWeight: "bold" }}>{totalIncl.toLocaleString()}</td>
    </tr>
  </tbody>
</table>


      <div style={styles.noteRow}>
        <div><b>Note:</b></div>
      </div>

      <div style={styles.footer}>
        <div>
          <div><b>Sales Tax:</b> {totalTax.toLocaleString()}</div>
          <div><b>Net Tax Inc.Value:</b> {totalIncl.toLocaleString()}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={styles.signatureLine}></div>
          <div>Name & Designation: <b>{signature}</b></div>
        </div>
      </div>

      <div style={styles.bottom}>
        <QRCodeSVG value={fbr_qrcode} size={100} />
        <img src={fbrIcon} alt="FBR Icon" style={{ width: 100, height: 100 }} />
      </div>
    </div>
  );
});

export default InvoicePrint;

const styles = {
  invoice: {
    fontFamily: "serif",
    maxWidth: 800,
    margin: "40px auto",
    background: "#fff",
    border: "1.5px solid #bbb",
    borderRadius: 8,
    padding: 24,
    fontSize: 15,
    color: "#222",
    boxShadow: "0 4px 16px #0001",
  },

  heading: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 20,
    marginBottom: 10,
    textDecoration: "underline",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  block: {
    width: "48%",
    lineHeight: 1.4,
  },
  table: {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: 10,
  marginBottom: 10,
  fontSize: 14,
  border: "1px solid black",
},
th: {
  border: "1px solid black",
  padding: "6px",
  textAlign: "center",
  fontWeight: "bold",
  background: "#f2f2f2",
},
td: {
  padding: "6px",
  textAlign: "right",
  borderRight:"1px solid #000"
},
totalRow: {
  backgroundColor: "#e8e8e8",
},

  noteRow: {
    marginTop: 100,
    marginBottom: 10,
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 10,
  },
  signatureLine: {
    borderBottom: "1px solid #000",
    width: 150,
    height: 20,
    marginBottom: 4,
    marginLeft: "auto",
  },
  bottom: {
    marginTop: 40,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 20,
  },
};
